import { render, staticRenderFns } from "./ExtraConfigInput.vue?vue&type=template&id=339b0ff4&scoped=true"
import script from "./ExtraConfigInput.vue?vue&type=script&lang=js"
export * from "./ExtraConfigInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b0ff4",
  null
  
)

export default component.exports